/**
 * Τι σέρνεται τώρα στη σελίδα «Κατάλογος» (κατηγορία, προϊόντα, μέγεθος…). Ζει σε ref και όχι στο
 * dataTransfer: ο browser δεν δίνει τα δεδομένα του dataTransfer στο dragover, μόνο στο drop.
 */
import { useRef } from 'react';

export type DragPayload =
  | { kind: 'category'; key: string }
  | { kind: 'products'; keys: string[]; node: string }
  | { kind: 'row'; list: string; uid: string };

export interface DragState {
  current: DragPayload | null;
  start: (payload: DragPayload) => void;
  end: () => void;
}

export function useDragState(): DragState {
  const ref = useRef<DragState | null>(null);
  if (!ref.current) {
    const state: DragState = {
      current: null,
      start: payload => { state.current = payload; },
      end: () => { state.current = null; },
    };
    ref.current = state;
  }
  return ref.current;
}

/** Μετακινεί ένα στοιχείο σε νέα θέση (για λίστες με σύρσιμο ή Alt+↑/↓). */
export function moveItem<T>(list: T[], from: number, to: number): T[] {
  if (from < 0 || from >= list.length || to < 0 || to >= list.length || from === to) return list;
  const next = list.slice();
  const [item] = next.splice(from, 1);
  next.splice(to, 0, item);
  return next;
}

/** Θέση ρίψης πάνω σε γραμμή: πάνω ή κάτω μισό. */
export function dropHalf(e: { clientY: number; currentTarget: EventTarget }): 'before' | 'after' {
  const rect = (e.currentTarget as HTMLElement).getBoundingClientRect();
  if (!rect.height) return 'after';
  return e.clientY - rect.top < rect.height / 2 ? 'before' : 'after';
}
